import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Badge, Button, Card, ErrorAlert, StatCard } from '../components/ui';

type Any = Record<string, any>;

export function NieboGuardTvHealthSection() {
  const [data, setData] = useState<Any | null>(null);
  const [analytics, setAnalytics] = useState<Any | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const load = useCallback(async () => {
    setBusy(true); setError(null);
    try { const [health, stats] = await Promise.all([api.nieboguard.tvHealth(), api.nieboguard.tvAnalytics(30)]); setData(health); setAnalytics(stats); } catch (err) { setError(err); } finally { setBusy(false); }
  }, []);
  useEffect(() => { load().catch(setError); }, [load]);
  const session = data?.session;
  const youtube = data?.youtube;
  return (
    <>
      {error ? <ErrorAlert error={error} /> : null}
      <Card title="NG TV — System Health" actions={<Button size="sm" onClick={load} disabled={busy}>{busy ? 'Odświeżam…' : 'Odśwież'}</Button>}>
        <div className="nb-grid nb-grid--2" style={{ marginBottom: 12 }}>
          <StatCard value={session?.status ?? '—'} label="Sesja" />
          <StatCard value={youtube?.lifeCycleStatus ?? '—'} label="YouTube lifecycle" />
          <StatCard value={youtube?.streamStatus ?? '—'} label="Strumień" />
          <StatCard value={youtube?.healthStatus?.status ?? '—'} label="Health" />
        </div>
        <div className="nb-item__meta">
          <Badge tone={youtube?.healthStatus?.status === 'good' ? 'success' : youtube?.healthStatus?.status === 'bad' ? 'danger' : 'warning'}>{youtube?.healthStatus?.status ?? 'unknown'}</Badge>
          <span>Broadcast: {session?.youtubeBroadcastId ?? '—'}</span>
          <span>Renderer: {session?.rendererId ?? '—'}</span>
          <span>Ostatni heartbeat: {session?.lastHeartbeatAt ?? '—'}</span>
        </div>
        {youtube?.healthStatus?.configurationIssues?.length ? <pre className="nb-code" style={{ marginTop: 10 }}>{JSON.stringify(youtube.healthStatus.configurationIssues, null, 2)}</pre> : null}
        <div className="nb-grid nb-grid--2" style={{ marginTop: 16 }}>
          <StatCard value={data?.counts?.tracks ?? 0} label="Utwory" />
          <StatCard value={data?.counts?.approvedTracks ?? 0} label="Zatwierdzone utwory" />
          <StatCard value={data?.counts?.bulletins ?? 0} label="Biuletyny" />
          <StatCard value={data?.counts?.approvedBulletins ?? 0} label="Zatwierdzone biuletyny" />
        </div>
      </Card>
      <Card title="Analityka NG TV — 30 dni">
        <div className="nb-grid nb-grid--2">
          <StatCard value={analytics?.sessions?.total ?? 0} label="Sesje" />
          <StatCard value={`${analytics?.sessions?.uptimeMinutes ?? 0} min`} label="Łączny uptime" />
          <StatCard value={analytics?.rotations ?? 0} label="Rotacje 11–12 h" />
          <StatCard value={analytics?.broadcastCreated ?? 0} label="Utworzone broadcasty" />
          <StatCard value={analytics?.commandFailures ?? 0} label="Błędy komend" />
          <StatCard value={`${(analytics?.music?.costUsd ?? 0).toFixed(2)} USD`} label="Koszt muzyki" />
          <StatCard value={analytics?.music?.tracks ?? 0} label="Utwory" />
          <StatCard value={analytics?.bulletins?.approved ?? 0} label="Zatwierdzone biuletyny" />
        </div>
      </Card>

      <Card title="Sesja — szczegóły">
        <pre className="nb-code" style={{ maxHeight: 420, overflow: 'auto' }}>{JSON.stringify(session, null, 2)}</pre>
      </Card>
    </>
  );
}
